import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d045e678"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "cases"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "成功案例", -1));
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "video-wrapper"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "relative-product"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "相关产品", -1));
const _hoisted_11 = {
  class: "swiper-box"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["src"];
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation, Autoplay } from 'swiper';
import casesData from '@/data/cases';
import productData from '@/views/device-detail/data/product';
export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {
    const modules = [Navigation, Autoplay];
    const {
      VUE_APP_PUBLIC_PATH
    } = process.env;
    const path = VUE_APP_PUBLIC_PATH === '/' ? '/solution-detail/' : VUE_APP_PUBLIC_PATH + '/solution-detail/';
    const getRelativePath = number => {
      return path + `${number}.png`;
    };
    const $route = useRoute();
    const router = useRouter();
    const id = $route.params.id;
    const currentData = ref({});
    const keys = Object.keys(casesData);
    // 防止id被篡改导致页面数据出错
    if (!keys.includes(id)) {
      router.replace('/solution');
    }
    currentData.value = casesData[id];
    // 目前所有的解决方案的产品都是单模网关、多模网关、U高速天基物联网模组
    const productList = productData;
    const productIds = [0, 1, 2];
    const expertList = productIds.map(id => {
      return {
        ...productList[id],
        id
      };
    });
    const toDevice = id => {
      router.push(`/device-detail/${id}`);
    };
    const swiper = ref(null);
    const onSwiper = currentSwiper => {
      swiper.value = currentSwiper;
    };
    const toSwiper = isNext => {
      isNext ? swiper.value.slideNext() : swiper.value.slidePrev();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "header",
        style: _normalizeStyle({
          'background-image': `url(${currentData.value.bannerImg})`
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(currentData.value.title), 1)])], 4), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("p", _hoisted_5, _toDisplayString(currentData.value.solution), 1), _createElementVNode("img", {
        src: currentData.value.solutionImg,
        alt: "",
        class: "main-img"
      }, null, 8, _hoisted_6)]), currentData.value.video ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("video", {
        src: currentData.value.video,
        controls: "",
        autoplay: "",
        controlsList: "nodownload",
        loop: ""
      }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_unref(Swiper), {
        onSwiper: onSwiper,
        class: "swiper_container",
        "slides-per-view": 3,
        "space-between": 32,
        modules: modules,
        loop: "",
        observer: "",
        observeParents: "",
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(expertList), (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              onClick: $event => toDevice(item.id),
              class: "swiper_content"
            }, [_createElementVNode("img", {
              src: item.section2.img,
              alt: "",
              class: "p-img"
            }, null, 8, _hoisted_13), _createElementVNode("p", null, _toDisplayString(item.section2.headerTitle), 1)], 8, _hoisted_12)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => toSwiper(false)),
        class: "swiper-button-prev"
      }), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => toSwiper(true)),
        class: "swiper-button-next"
      })])])], 64);
    };
  }
});